import React from "react";

function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0"); // 01 → 09
  const month = date.toLocaleString("en-GB", { month: "short" }); // Sep
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}



function DocReportTable({ reports = [], isLoading, isSuccess }) {
  return (
    <div
      className="bg-white rounded-3 shadow-sm p-4"
      style={{ border: "1.3px solid #f3f4f8" }}
    >
      <div
        className="fw-bold mb-3"
        style={{ fontSize: "1.15rem", color: "#232323" }}
      >
        Patient Reports
      </div>

      {/* Loading State */}
      {isLoading && (
        <div className="text-center py-4 text-muted">Loading reports...</div>
      )}

      {/* No Data */}
      {!isLoading && isSuccess && reports?.length === 0 && (
        <div className="text-center py-4 text-muted">No reports available</div>
      )}

      {/* Table */}
      {!isLoading && isSuccess && reports?.length > 0 && (
        <div className="table-responsive">
          <table
            className="table mb-0 align-middle"
            style={{
              borderCollapse: "separate",
              borderSpacing: 0,
              borderRadius: 13,
              overflow: "hidden",
              fontSize: "0.95em",
            }}
          >
            <thead style={{ background: "#f7f7f7" }}>
              <tr>
                <th style={{ padding: "10px 18px", borderBottom: "1.5px solid #eceef2", fontWeight: 600 }}>
                  Patient Name
                </th>
                <th style={{ padding: "10px 18px", borderBottom: "1.5px solid #eceef2", fontWeight: 600 }}>
                  Report Date
                </th>
                <th style={{ padding: "10px 18px", borderBottom: "1.5px solid #eceef2", fontWeight: 600 }}>
                  Status
                </th>
                <th style={{ padding: "10px 18px", borderBottom: "1.5px solid #eceef2", fontWeight: 600, textAlign: "center" }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {reports.map((row, idx) => (
                <tr
                  key={row.patientIDUniqueID + idx}
                  style={{
                    background: idx % 2 === 0 ? "#fff" : "#fafbfc",
                  }}
                >
                  <td
                    style={{
                      padding: "12px 18px",
                      verticalAlign: "middle",
                      fontWeight: 500,
                      color: "#232438",
                    }}
                  >
                    {row.fullName}
                  </td>
                  <td
                    style={{
                      padding: "12px 18px",
                      verticalAlign: "middle",
                      color: "#4a4b53",
                    }}
                  >
                    {formatDate(row.reportDate)}
                  </td>
                  <td style={{ padding: "12px 18px", verticalAlign: "middle" }}>
                    <span
                      className={`badge rounded-pill ${
                        row.status === "Completed"
                          ? "bg-success-subtle text-success"
                          : "bg-warning-subtle text-warning"
                      }`}
                      style={{ fontSize: "0.85rem" }}
                    >
                      {row.status}
                    </span>
                  </td>
                  <td
                    style={{
                      padding: "12px 18px",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#4C73E3",
                        cursor: "pointer",
                        fontSize: "1rem",
                      }}
                      title="View"
                      tabIndex={0}
                      role="button"
                    >
                      <i className="fa-regular fa-eye" />
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default DocReportTable;
